var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "music-player-marquee" }, [
    _vm.text
      ? _c(
          "p",
          _vm._l(2, function (index) {
            return _c("span", {
              key: index,
              style: { minWidth: `${_vm.offsetWidth}px` },
              domProps: { textContent: _vm._s(_vm.text) },
            })
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }